import user from "@/api/user"
import untils from "@/until/until"
import router from '@/router/router'
import { Toast } from 'vant'

const noBindLink = ['/login/survey']

const wxLogin = (obj, appid) => {
  return new Promise((resolve, reject) => {
    if (untils.isWechat()) {
      let code = untils.getUrlParam("code");

      if (code) {
        const codeUsedKey = `wxCodeUsed:${code}`;
        if (sessionStorage.getItem(codeUsedKey)) {
          console.warn("当前 code 已使用，避免重复请求");
          return;
        }
        sessionStorage.setItem(codeUsedKey, '1');

        let codeObj = { code };
        user.wxLogin(codeObj, res => {
          if (res.code == 200) {
            localStorage.setItem('userInfo', JSON.stringify(res.data));
            localStorage.setItem('sessionKey', res.data.sessionKey);
            localStorage.setItem('openid', res.data.openId);

            if (res.data.phone === null || res.data.phone === '') {
              // 手机号未绑定，根据路径判断是否跳转绑定页
              // if (!noBindLink.includes(document.location.pathname)) {
              //   router.replace('/login?loginType=2&wxCode=' + code)
              // } else {
                resolve(res);
              // }
            } else {
              resolve(res);
            }

          } else if (res.code === 40163) {
            // code 已被使用，重新授权，添加随机 state 防止缓存
            const randomState = Math.random().toString(36).substr(2);
            let url = encodeURIComponent(obj);
            window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=${randomState}#wechat_redirect`;

          } else {
            Toast({
              message: res.msg,
              position: 'bottom'
            });
            reject(res);
          }
        });

      } else {
        // 无 code，首次进入发起授权
        const randomState = Math.random().toString(36).substr(2);
        let url = encodeURIComponent(obj);
        window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=${randomState}#wechat_redirect`;
      }
    }
  });
};

// 一次性订阅消息
const weSubscribeMessage = (obj, appid, templateId) => {
  return new Promise(() => {
    if (untils.isWechat()) {
      let url = encodeURIComponent(obj);
      window.location = `https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=${appid}&scene=1000&template_id=${templateId}&redirect_url=${url}&reserved=test#wechat_redirect`;
    }
  });
};

// 获取微信 appId
const getWechatAppId = () => {
  return new Promise((resolve, reject) => {
    user.getAppId({}, res => {
      if (res.code == 200) {
        resolve(res);
        // wxLogin(window.location.href, res.data.appId);
      } else {
        Toast({
          message: res.msg,
          duration: 1500,
          forbidClick: true
        });
        reject(res);
      }
    });
  });
};

export default {
  getWechatAppId,
  wxLogin,
  weSubcribeMessage: weSubscribeMessage
};
